import axios from 'axios';
import {baseUrl} from "../utilities/config";

export const getStudentDetails = async() => {
    let config = {
        method: 'get',
        url: `${baseUrl}students`,
        headers: { 
          'Content-Type': 'application/json'
        }
      };
    return axios(config).then(function (response) {
          return response
      })
      .catch(function (error) {
        return error.response;
      });    
}
